export default __webpack_public_path__ + "static/media/logo-small.6bbf5794.png";